module.exports = __webpack_public_path__ + "media/witchy-laugh.015dc8d5.mp3";